// extracted by mini-css-extract-plugin
module.exports = {"map":"NumberpadOverlay_map__2pq9z","wrapper":"NumberpadOverlay_wrapper__iJeQV","frame-popup":"NumberpadOverlay_frame-popup__3XMxL"};